<template>
  <div>
    <Navigation />
    <section class="section__container top__container blog__details">
      
      <div class="section__container center__text">
      <h1 class="title">FACILITEZ LA PROGRAMMATION DE VOS CAMPAGNES SMS</h1>
      </div>
      <h2 class="title center__text">Lancez vos campagnes instantanément ou programmez des envois anticipés</h2>
    </section>
    <div class="two__cards sixty__container">
      <div class="card">
        <img
          class="card__image"
          src="/../images/planification/ENVOI-IMMEDIAT.png"
          alt="planification"
        />
        <div class="card__details center__text">
          <h3>ENVOI INSTANTANÉ</h3>
          <p>
            Une fois que vous avez validé votre campagne SMS, l'envoi est déclenché instantanément. 
            Notre plateforme se charge rapidement des envois immédiats, permettant à vos contacts de 
            recevoir les premiers SMS en quelques secondes seulement après la validation.
          </p>
        </div>
      </div>

      <div class="card">
        <img
          class="card__image"
          src="/../images/planification/ENVOI-DIFFERE.png"
          alt="planification"
        />
        <div class="card__details center__text">
          <h3>PLANIFICATION D'ENVOI</h3>
          <p>
            Planifiez l'envoi de vos campagnes SMS en définissant une date et une heure précises à l'avance. 
            Les envois seront déclenchés selon votre programmation. Retrouvez facilement vos campagnes 
            programmées dans une section dédiée de votre espace client.
          </p>
        </div>
      </div>
      <div class="card">
        <img
          class="card__image"
          src="/../images/planification/ENVOI-PAR-TRANCHES-HORAIRES.png"
          alt="planification"
        />
        <div class="card__details center__text">
          <h3>ENVOI PROGRESSIF</h3>
          <p>
            Étalez la durée d'envoi de votre campagne pour gérer efficacement 
            les retours sans être submergé par leur afflux.
          </p>
        </div>
      </div>
      <div class="card">
        <img
          class="card__image"
          src="/../images/planification/ENVOI-ANNIVERSAIRE.png"
          alt="planification"
        />
        <div class="card__details center__text">
          <h3>ENVOI D'ANNIVERSAIRE</h3>
          <p>
            Personnalisez la date d'envoi en utilisant un
             champ de votre base de contacts tel que la date d'anniversaire.
          </p>
        </div>
      </div>
    </div>
    
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
export default {
  components: {
    Navigation,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
